(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CoreFilterByController', coreFilterByController)

  /* @ngInject */
  function coreFilterByController ($scope, $attrs, $timeout) {
    $scope.flags = {
      showFiltersButton: true
      // showUsers: true
    }

    const api = {
      _initFiltersDropdowns,
      _handleToggleDropdown
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownParams = {
        action: 'nothing',
        direction: 'downward',
        fullTextSearch: true
      }

      api._initFiltersDropdowns(dropdownParams)
    }

    $scope.$watchCollection('params', () => {
      const { users, groups, status, permissions } = $scope.params

      if (users?.length && groups?.length && status?.length && permissions?.length) {
        $scope.flags.showFiltersButton = false
      } else {
        $scope.flags.showFiltersButton = true
      }
    })

    $scope.openDropdown = api._handleToggleDropdown

    $scope.clearAllFilters = () => {
      $scope.params.users = []
      $scope.params.groups = []
      $scope.params.status = []
      $scope.params.permissions = []
    }

    /**
     *  @param {object | string} dropdownParams - config options for semantic dropdown
     *  @description - Init all filters dropdown, according to array of filters
     */
    function _initFiltersDropdowns (dropdownParams) {
      $scope.filters.forEach(filter => {
        api._handleToggleDropdown(dropdownParams, filter.type)
      })
    }

    /**
     *  @param {object | string} options - config options for semantic dropdown
     *  @param {string} filter - filter name for get dropdown element
     *  @description - this method initialize the dropdown menu
     */
    function _handleToggleDropdown (options, filter) {
      $timeout(() => {
        $attrs.$$element.find(`filter-${filter}-dropdown .filter-${filter}-dropdown`).dropdown(options)
      }, 100, false)
    }
  }
})()
